import React, { useState, useContext, useEffect, useRef } from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { ObjModal } from '../../../../contexts';
import { Editor } from '@tinymce/tinymce-react';
import LaunchIcon from '@mui/icons-material/Launch';

const Text = ( { label, db, value, type = 'text', disabled, formId = 'gen' } ) => {
    const { oid, setDraftValues } = useContext( ObjModal );
    const [ v, setV ] = useState( '' );
    const [ isValid, setIsValid ] = useState( true );
    const [ errorMessage, setErrorMessage ] = useState( '' );
    const [ showEditor, setShowEditor ] = useState( false );
    const [ editorReady, setEditorReady ] = useState( false );
    const editorRef = useRef( null );
    const placeholderRef = useRef( null );

    const startEdit = () => {
        setShowEditor( true );
        setDraftValues( prevState => (
            {
                ...prevState,
                tmpDirty: true
            }
        ) );
    }

    const handleDraft = ( e ) => {
        switch ( type ) {
            // case 'text':
            case 'textarea':
                // editorRef.current.save();
                const body = editorRef.current.getContent();
                setV( body );
                const clean = body.replace( /^<p>(.*)<\/p>$/, "$1" ).replace( /&nbsp;$/, '' ).replace( /^&nbsp;/, '' ).replace( /^<br>$/, '' );
                setDraftValues( prevState => {
                    delete prevState.tmpDirty;
                    return {
                        ...prevState,
                        [db]: clean
                    }
                } );
                
                break;

            default:
                setV( e.target.value );
                setDraftValues( prevState => (
                    {
                        ...prevState,
                        [db]: e.target.value
                    }
                ) );
        }
    }

    const validateDate = ( dateString ) => {
        // Regex to check if the date is in the correct format (YYYY-MM-DD)
        const regex = /^\d{4}-\d{2}-\d{2}$/;
        
        if ( regex.test( dateString.replace( /T.*/, '' ) ) ) {
          const date = new Date( dateString );
          if ( !isNaN( date.getTime() ) ) {
            setIsValid( true );
            setErrorMessage( '' );
            return true;
          } else {
            setIsValid( false );
            setErrorMessage( 'Please correct this date: ' + dateString );
          }
        } else {
          setIsValid( false );
          setErrorMessage( 'Please correct this date: ' + dateString );
        }

        return false;
    };

    useEffect( () => {
        if ( editorReady && editorRef && editorRef.current ) {
            editorRef.current.selection.select( editorRef.current.getBody(), true );
            editorRef.current.selection.collapse( false );
            editorRef.current.focus();
        }
    }, [ editorReady ] );

    useEffect( () => {
        switch ( type ) {
            case 'date':
                if ( value ) {
                    if ( validateDate( value ) ) {
                        const d = new Date( value.match( 'T' ) ? value : value + 'T12:00:00' );
                        const dString = new Intl.DateTimeFormat( 'en-CA', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            timeZone: 'America/New_York'
                        } ).format( d ).replace( /\//g, '-' );

                        setV( dString );
                    }
                }
                break;

            case 'text':
            case 'textarea':
                if ( value ) {
                    setV( String( value ) );
                }
                break;

            default:
                if ( value ) {
                    setV( value );
                }
        }
    }, [ type, value, db ] );

    return (
        <Col className='tf-obj-data-element align-items-center'>
            <Form.Group as={Row} className='tf-form-group align-items-top' controlId={`${formId}-${db}`}>
                <Form.Label column xs='auto' className='col-md-auto p-0 tf-form-label'>{label}</Form.Label>
                {
                    ( type === 'textarea' ) ? (
                        <Col key={`${oid}-tinymce`} className='tf-form-text-field me-1'>
                            {
                                ( showEditor ) ? (
                                    <Editor
                                        id={`${formId}-${db}`}
                                        tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                                        onInit={ ( evt, editor ) => {
                                            editorRef.current = editor;
                                            setEditorReady( true );
                                        } }
                                        init={ {
                                            toolbar: false, 
                                            menubar: false,
                                            browser_spellcheck: true,
                                            // hidden_input: false,
                                            forced_root_block: '',
                                            valid_elements: '*[*]'
                                        } }
                                        inline={true}
                                        initialValue={ ( value ) ? String( value ) : '' }
                                        onBlur={handleDraft}
                                    />
                                ) : (
                                    <div onClick={startEdit} onFocus={startEdit} tabIndex={0} ref={placeholderRef} dangerouslySetInnerHTML={ { __html: v } } style={ { minHeight: '20px', padding: '5px', cursor: 'text' } }></div>
                                )
                            }
                        </Col>        
                    ) : (
                        ( type === 'date' ) ? (
                            <Col xs='auto' className='tf-form-text-field me-1'>
                                <Form.Control type='text' onFocus={ ( e ) => e.target.type = 'date' } onBlur={ ( e ) => e.target.type = 'text' } value={v} onChange={handleDraft} placeholder='' isInvalid={!isValid} />
                                <Form.Control.Feedback type="invalid">
                                    {errorMessage}
                                </Form.Control.Feedback>
                            </Col>
                        ) : ( type === 'url' ) ? (
                            <Col className='tf-form-text-field me-1'>
                                <Row className='align-items-center'>
                                    <Col><Form.Control type={type} value={v} onChange={handleDraft} /></Col>
                                    {
                                        ( v && v.length ) ? (
                                            <Col xs='auto'><a href={v} target='_blank' rel='noreferrer'><LaunchIcon fontSize='small' /></a></Col>
                                        ) : (
                                            null
                                        )
                                    }
                                </Row>
                            </Col>
                        ) : (
                            <Col className='tf-form-text-field me-1'>
                                <Form.Control type={type} value={v} onChange={handleDraft} />
                            </Col>
                        )
                    )
                }
            </Form.Group>
        </Col>
    )
}

export default Text;